module.exports = __webpack_public_path__ + "static/SportsScholarshipImg-c4de457a5487b2babe590e720d2890fc.png";